import React from "react";

import { CreditCardIcon, OverflowTooltip } from "components";
import { CreditCardTypes, PaymentTypes, PaymentMethodValues } from "types";

import styles from "../../paymentMethods.module.scss";

const paymentInformationColumn = () => ({
	Header: "Payment Information",
	accessor: "paymentInformation",
	disableSortBy: true,
	Cell({ row }) {
		const original: PaymentMethodValues = row.original;

		const {
			bankAccountName,
			paymentType,
			bankName,
			cardHolderName,
			cardNumber,
			expirationDate,
			cardType,
			routingNumber,
		} = original;
		const paymentMethod = PaymentTypes.getByValue(paymentType?.value);

		return (
			<>
				{paymentMethod?.displayName === PaymentTypes.ach.displayName ? (
					<OverflowTooltip onlyOnLaptop title={bankAccountName}>
						<div>
							{bankAccountName} {routingNumber?.value}
						</div>
						<div className={styles.textGray}>{bankName}</div>
					</OverflowTooltip>
				) : (
					<OverflowTooltip onlyOnLaptop title={cardHolderName}>
						<div className={styles.creditNumber}>
							<div className={styles.creditCardSign}>
								<CreditCardIcon
									name={
										CreditCardTypes.getByValue(cardType)
											?.name
									}
								/>
							</div>
							<div className={styles.creditCardSign}>
								{CreditCardTypes.getByValue(cardType)
									?.displayName || ""}
							</div>
							<div>{cardNumber}</div>
						</div>
						<div
							className={styles.textGray}
						>{`Expiration Date: ${expirationDate}`}</div>
					</OverflowTooltip>
				)}
			</>
		);
	},
});

export default paymentInformationColumn;
